import React from 'react';
import PropTypes from 'prop-types';
import RouterNavigationPrompt from 'react-router-navigation-prompt';

import ConfirmDialog from './confirmDialog.component';
import { compareOnlyPathName } from './navigationPrompt.utils';


export const IMPORTED_DATA_PENDING_TITLE = 'Do you want to leave this page?';
export const IMPORTED_DATA_PENDING_MESSAGE = 'Leaving this page will delete imported data that you have not saved by clicking Submit.';

export const PENDING_ENTRIES_TITLE = 'Do you want to leave this page?';
export const PENDING_ENTRIES_MESSAGE = 'Leaving this page will revert all pending entries to their previous values.';

export const DISCARD_UNSAVED_CHANGES_TITLE = 'Do you want to leave this page?';
export const DISCARD_UNSAVED_CHANGES_MESSAGE = 'Leaving this page will discard all unsaved changes.';

export const DEFAULT_MESSAGE = 'Changes you made may not be saved.';

const NavigationPrompt = ({
  show,
  title,
  message,
  onDiscard,
  isSubmitDisabled,
}) => {
  if (show) {
    return (
      <RouterNavigationPrompt when={compareOnlyPathName} renderIfNotActive>
        {({ onConfirm, onCancel, isActive }) => (
          <ConfirmDialog
            onConfirm={onConfirm}
            onCancel={onCancel}
            title={title}
            message={message}
            isVisible={isActive}
            onDiscard={onDiscard}
            isSubmitDisabled={isSubmitDisabled}
          />
        )}
      </RouterNavigationPrompt>
    );
  }

  return null;
};

NavigationPrompt.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.node,
  onDiscard: PropTypes.func,
  isSubmitDisabled: PropTypes.bool,
};

export default NavigationPrompt;
